import TC from './TweetCard'

export default TC
